<template>
  <footer class="footer">
    <div class="container">
      <div class="row">
        <div class="col-lg-2">
          <a :href="footerLogo.link" :aria-label="footerLogo.label_en_us">
            <div class="footer-logo"></div>
          </a>
        </div>
        <div class="col-lg-10">
          <div class="footer-social">
            <div class="footer-social">
              Connect with us
              <ul class="">
                <li v-for="item of footerSocialLinks" :key="item.label_en_us">
                  <ExternalLink :href="item.link" :class="item.iconClass">
                    <span class="sr-only">{{ item.label_en_us }}</span>
                  </ExternalLink>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-aside">
        <small class="footer-aside-copyright"
          >©
          <span id="footer-aside-copyright-year">{{ currentYear }}</span> APNIC
          <span class="footer-aside-copyright-abn"
            >ABN&nbsp;42&nbsp;081&nbsp;528&nbsp;010</span
          >
        </small>
        <ul class="footer-aside-links">
          <li v-for="item of footerAsideLinks" :key="item.label_en_us">
            <ExternalLink :href="item.link">
              {{ item.label_en_us }}
            </ExternalLink>
          </li>
        </ul>
      </div>
    </div>
  </footer>
</template>

<script>
import ExternalLink from '../ExternalLink';
import { mapState } from 'vuex';

export default {
  components: {
    ExternalLink
  },
  computed: {
    ...mapState('dataStore', ['themeDataList']),

    currentYear() {
      return new Date().getFullYear();
    },

    footerAsideLinks() {
      return this.themeDataList.footerAsideLinks || [];
    },

    footerSocialLinks() {
      return this.themeDataList.footerSocialLinks || [];
    },

    footerLogo() {
      return this.themeDataList.footerLogo || {};
    }
  }
};
</script>

<style scoped>
.footer {
  position: relative;
  background-color: #262626;
  padding: 16px;
  padding: 1rem;
  width: 100%;
  font-size: 14.4px;
  font-size: 0.9rem;
  color: #fff;
}

.row {
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
}

.col-lg-10 {
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
}
.footer .footer-social ul {
  display: inline-block;
  margin: 0 0 0 16px;
  padding: 0;
  list-style-type: none;
  vertical-align: middle;
}
.logo-container {
  margin: 0;
  background-size: auto 28px;
  height: 25px;
}
.logo-container img {
  display: flex;
  height: 50px;
  width: 130px;
  padding: 10px;
}
.footer-aside {
  clear: both;
  margin: 16px 0 8px;
  border-top: 1px solid #e6e6e6;
  padding: 16px 0;
}
.footer-aside-copyright {
  float: left;
  margin: 0 0 16px 0;
  text-align: left;
}
.footer-aside-links {
  float: right;
  margin: 0;
  padding: 0;
  max-width: none;
  list-style-type: none;
}
.footer-logo {
  margin: 0;
  background: url('https://webdist.data.apnic.net/web-framework-theme/3.0.0/images/apnic-reverse.svg')
    no-repeat;
  background-size: auto 28px;
  height: 25px;
}
.footer-aside-copyright-abn {
  display: inline-block;
  margin-left: 16px;
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}
.footer li {
  margin-right: 5px !important;
}
</style>
